export let TimeRangeNames = /*#__PURE__*/function (TimeRangeNames) {
  TimeRangeNames["Today"] = "Today";
  TimeRangeNames["Tomorrow"] = "Tomorrow";
  TimeRangeNames["ThisWeek"] = "This Week";
  TimeRangeNames["ThisWeekend"] = "This Weekend";
  TimeRangeNames["NextWeek"] = "Next Week";
  TimeRangeNames["Upcoming"] = "Upcoming";
  TimeRangeNames["Never"] = "Never";
  return TimeRangeNames;
}({});